var _defs, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 109.1 73.2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    d: "M19.4 0A18.7 18.7 0 000 19.3a18.9 18.9 0 0019.4 19.5 18.7 18.7 0 0014-5.6 18.8 18.8 0 005.4-14A18.7 18.7 0 0019.4 0Zm6.3 25.7a8.6 8.6 0 01-6.3 2.5 8.5 8.5 0 01-6.2-2.5 8.7 8.7 0 01-2.4-6.4A8.6 8.6 0 0113 13a8.4 8.4 0 016.3-2.5 8.4 8.4 0 018.7 8.8 8.7 8.7 0 01-2.4 6.4Zm53.1 32.8a13.4 13.4 0 01-11.5-5.6q-4-5.7-4-16 0-10 4-15.6a13.4 13.4 0 0111.5-5.6 12.6 12.6 0 018.6 3 13.3 13.3 0 014.2 8.2H109q-1.4-12-9.5-19T78.3 1q-14.5 0-23.7 9.8T45.3 37q0 16.4 9.2 26.3t23.7 9.9q13.2 0 21.6-7.1 8.3-7 9.3-19.6H91.6q-1.6 12-12.8 12Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 72 168"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 132,
    r: 36,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ef4444",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    d: "M36 12v120"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    dur: "1s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 0; 0 18; 0 0"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 118 278"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M115 218.2c0 31.4-25 56.8-56 56.8S3 249.6 3 218.2a57 57 0 0124-46.6V35.5a32 32 0 1164 0v136a57 57 0 0124 46.7ZM63 83h28M63 51h28m-28 64h28"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    viewBox: "0 0 118 278"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 72,
    height: 168,
    transform: "translate(23 87)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 118,
    height: 278
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -7.2,
    x2: 116.4,
    y1: 36.3,
    y2: 250.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#515a69",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6b7280",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384354",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -8.7,
    x2: 117.9,
    y1: 33.7,
    y2: 253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 109.1,
    height: 73.2,
    transform: "translate(314 250)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    width: 118,
    height: 278,
    transform: "translate(197 117)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.a469e59ad8cfb5ce6d673cac42ae4b2b.svg";
export { ForwardRef as ReactComponent };